import { Megaphone } from "lucide-react";
import UseCasePage from "@/components/site/UseCasePage";

const UseCasePromotionalSms = () => (
  <UseCasePage
    slug="promotional-sms"
    metaTitle="Promotional SMS Campaigns | Yootelco"
    metaDescription="Run bulk promotional SMS campaigns with reliable delivery. Yootelco helps businesses reach customers with offers and announcements at scale."
    title="Promotional SMS Campaigns"
    heroDescription="Run bulk promotional SMS campaigns with reliable delivery, wherever your customers are. Yootelco helps businesses reach audiences with offers, announcements, and time-sensitive promotions at scale."
    whatItIs="Promotional SMS is a bulk messaging use case where businesses send offers, discounts, product launches, or announcements directly to customers' phones. Because SMS has near-universal reach and high open rates, it's one of the most direct ways to get a time-sensitive message seen quickly."
    heroIcon={Megaphone}
    challenges={[
      "Low open rates on other channels like email",
      "Messages blocked by spam filters or carrier restrictions",
      "Missing consent and opt-in management, creating compliance risk",
      "Difficulty scaling sends across regions and sender IDs",
      "No visibility into delivery and engagement performance",
    ]}
    solutions={[
      "Direct carrier connections for reliable, fast delivery",
      "Managed sender ID and compliance support across markets",
      "Real-time delivery reporting so you know what landed",
      "Support for SMS, Viber, and RCS from one platform",
      "Built to handle high-volume sends without bottlenecks",
    ]}
    benefits={[
      { title: "Wider Reach", description: "Get offers seen through a channel nearly everyone checks." },
      { title: "Faster Response", description: "Time-sensitive promotions land quickly, before the moment passes." },
      { title: "Multi-Channel Delivery", description: "Run campaigns across SMS, Viber, and RCS." },
      { title: "Delivery Visibility", description: "Track what was delivered and when." },
    ]}
    audiences={[
      "Retailers running seasonal or flash sales",
      "Marketing teams launching new products",
      "Agencies managing campaigns for multiple clients",
      "Subscription or membership businesses driving renewals",
    ]}
    faqs={[
      { question: "What is promotional SMS messaging?", answer: "Promotional SMS is the practice of sending marketing messages — offers, discounts, announcements — directly to customers' phones, typically at scale across an opted-in contact list." },
      { question: "Is promotional SMS legal?", answer: "Yes, provided recipients have given prior consent to receive marketing messages and are given a clear way to opt out. Requirements vary by country and should be checked for each market you're sending into." },
      { question: "Can I run promotional campaigns across multiple channels?", answer: "Yes, Yootelco supports promotional messaging over SMS, Viber Business Messages, and RCS from a single platform." },
      { question: "How do I track campaign performance?", answer: "Delivery reporting is available so you can see what was sent, delivered, and, where supported, opened or clicked." },
    ]}    
    ctaTagline="Talk to our team about running promotional SMS campaigns across SMS and RCS."
  />
);

export default UseCasePromotionalSms;
